// hooks/useRecaptchaV3.js
import { useEffect, useState } from "react";

const RECAPTCHA_SRC = "https://www.google.com/recaptcha/api.js?render=";

export function useRecaptchaV3(siteKey) {
    const [ready, setReady] = useState(false);

    useEffect(() => {
        if (!siteKey || typeof window === "undefined") return;

        const scriptId = "recaptcha-v3-script";

        if (document.getElementById(scriptId)) {
            setReady(true);
            return;
        }

        const script = document.createElement("script");
        script.id = scriptId;
        script.src = `${RECAPTCHA_SRC}${siteKey}`;
        script.async = true;
        script.onload = () => {
            setReady(true);
        };
        document.body.appendChild(script);
    }, [siteKey]);

    const execute = async (action) => {
        if (!ready || !window.grecaptcha) throw new Error("reCAPTCHA not ready");
        return await window.grecaptcha.execute(siteKey, { action });
    };

    return { execute, ready };
}
